<template>
    <div id="bar">
        <apexchart type="bar" height="200" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
export default {
  components: {
    apexchart: VueApexCharts,
  },
  name: 'Vue Chart',
  props: {
    Y: Array,
    X: Array,
    title: String
  },
 data: function () {
  return {
   chartOptions: {
    chart: {
      id: 'vuechart-example',
    },
    xaxis: {
      categories: this.X,
    },
    title: {
        text: this.title,
        style: {
            fontSize: '16px'
        },
        offsetY: 5
    },
   },
   series: [{
    name: 'Vue Chart',
    data: this.Y
   }]
  }
 },
}
</script>
<style>
    #bar {
        border: 1px solid #AAA;
        border-radius: 7px;
        box-shadow: 0px 1px 22px -12px #607D8B;
        @media (max-width: 768px ){
      }
    }
</style>